import React, { useState } from "react";
import "./QuarterForm.css";

function QuarterForm({ onAdd }) {
  const [form, setForm] = useState({
    quarter_no: "",
    block: "",
    type: "",
    rank: "",
    resident: "",
    pno_no: "",
    mobile_no: "",
    allotment_date: "",
    allotment_year: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ Block Names (UI) → A,B,C mapping (backend)
  const blockNamesList = [
    "Reserve Police Line",
    "Traffic Police Line",
    "K D Line",
    "Police Office Complex",
    "PS Railbazaar",
    "PS Govindnagar",
    "PS Swaroopnagar",
    "PS Nazirabad",
    "RK Chauki Nazirabad",
    "PS Amrapur",
    "PS Fazalganj",
    "PS Gwaltoli",
    "PS Sisamau",
    "PS Chamanganj",
    "PS Bajriya",
    "PS Anwarganj",
    "PS Raipurva",
    "Chauki Coperganj Rajpurva",
    "PS Bapupurva",
    "PS Juhi",
    "PS Cantt",
    "PS Chakeri",
    "Friend Colony Chakeri",
    "PS Barra",
    "PS Kotwali",
    "PS Feelkhana (Patkapur Chauki)",
    "PS Harvanshmohal",
    "PS Kalyanpur",
    "Kalyanpur Zone Residence",
    "PS Panki",
    "PS Bithoor",
    "PS Nawabganj",
    "PS Ghatampur",
    "PS Chaubepur",
    "PS Shivrajpur",
    "PS Sachedi"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.quarter_no) newErrors.quarter_no = "Required";
    if (!form.block) newErrors.block = "Required";
    if (!form.type) newErrors.type = "Required";

    if (form.resident && !form.rank) newErrors.rank = "Required";
    if (form.resident && !form.pno_no) newErrors.pno_no = "Required";

    if (form.mobile_no && !/^\d{10}$/.test(form.mobile_no)) {
      newErrors.mobile_no = "Must be 10 digits";
    }

    if (form.resident && !form.allotment_date) newErrors.allotment_date = "Required";
    if (form.resident && !form.allotment_year) newErrors.allotment_year = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const cleanedForm = { ...form };

      Object.keys(cleanedForm).forEach(key => {
        if (cleanedForm[key] === "" && !["quarter_no", "block", "type"].includes(key)) {
          cleanedForm[key] = null;
        }
      });

      await onAdd(cleanedForm);

      setForm({
        quarter_no: "",
        block: "",
        type: "",
        rank: "",
        resident: "",
        pno_no: "",
        mobile_no: "",
        allotment_date: "",
        allotment_year: "",
      });

      setErrors({});
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ Types
  const types = ["Type 1", "Type 2", "Type 3"];

  // ✅ Updated Ranks
  const ranks = [
    "Inspector",
    "Sub-Inspector",
    "Assistant Sub Inspector",
    "Head Constable",
    "Constable",
    "Follower",
    "Cook",
    "Sweeper",
    "OP",
    "Driver",
    "Tailor",
    "Armourer",
    "Waterman",
    "Radio Messenger",
    "Staff Nurse",
    "APO",
    "Others"
  ];

  // ✅ Years till 1947
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1947 + 1 },
    (_, i) => currentYear - i
  );

  return (
    <div className="quarter-form-card">
      <h2>Add New Quarter</h2>

      <form onSubmit={handleSubmit} className="quarter-form">
        <div className="form-grid">

          <input
            name="quarter_no"
            placeholder="Quarter No (e.g. A-1)"
            value={form.quarter_no}
            onChange={handleChange}
          />

          {/* ✅ Block Dropdown */}
          <select name="block" value={form.block} onChange={handleChange}>
            <option value="">Select Block</option>
            {blockNamesList.map((name, index) => (
              <option key={index} value={String.fromCharCode(65 + index)}>
                {name}
              </option>
            ))}
          </select>

          {/* Type */}
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="">Select Type</option>
            {types.map(t => <option key={t}>{t}</option>)}
          </select>

          <input name="resident" placeholder="Resident Name" value={form.resident} onChange={handleChange} />

          <select name="rank" value={form.rank} onChange={handleChange}>
            <option value="">Select Rank</option>
            {ranks.map(r => <option key={r}>{r}</option>)}
          </select>

          <input name="pno_no" placeholder="PNO No" value={form.pno_no} onChange={handleChange} />
          <input name="mobile_no" placeholder="Mobile" value={form.mobile_no} onChange={handleChange} />

          <input type="date" name="allotment_date" value={form.allotment_date} onChange={handleChange} />

          <select name="allotment_year" value={form.allotment_year} onChange={handleChange}>
            <option value="">Select Year</option>
            {years.map(y => <option key={y}>{y}</option>)}
          </select>

        </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Adding..." : "Add Quarter"}
        </button>
      </form>
    </div>
  );
}

export default QuarterForm;